import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import api from "../../api";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../../utils/toastMessages";
import crossIcon from "../../assets/icons/crossIcon.png";
import fileIcon from "../../assets/icons/sboxfile.png";
import linkIcon from "../../assets/icons/sboxlink.png";
import { BsArrowRepeat } from "react-icons/bs";
import { formatFileType } from "../../utils/FileType";
import uploadIcon from "../../assets/icons/material-symbols_file-upload.png";
import { toast } from "react-toastify";
import { formatDateToUserTimeZone } from "../../utils/formatDate";
import axios from "axios";
import { validateFileName } from "../../utils/validateFileName";
import { useTableSort } from "../../hooks/useTableSort";
import { SortableHeader } from "../../components/SortableHeader";

const BASE_URL = `${process.env.REACT_APP_API_URL}/users`;
const DEPARTMENTS_URL = `${process.env.REACT_APP_API_URL}/departments`;

const TrainingManagement = ({ uploadedFiles = [] }) => {
  const fileInputRef = useRef();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFilesList, setUploadedFilesList] = useState([]);
  const [selectedFileForPreview, setSelectedFileForPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(null);

  // 🆕 summary states
  const [summaryDataList, setSummaryDataList] = useState([]);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  // const [selectedrole, setSelectedRole] = useState("user");
  const [role, setRole] = useState("personal");
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedUserObj, setSelectedUserObj] = useState(null);
  const [Description, setDescription] = useState("");

  const [departments, setDepartments] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [isDeptLoading, setIsDeptLoading] = useState(false);

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const fetchUploadedFiles = async () => {
    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/uploaded-files/files`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (!res.ok) throw new Error("Failed to fetch uploaded files");
      const data = await res.json();
      // setUploadedFilesList(data);
      // ✅ filter by MIME types
      const allowedMimeTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "text/plain",
        "text/csv",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",

        // PowerPoint
        "application/vnd.ms-powerpoint", // .ppt
        "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx

        // Audio & Video
        "audio/mpeg", // .mp3
        "video/mp4", // .mp4

        // Images
        "image/png", // .png
        "image/jpeg", // .jpeg / .jpg
      ];

      // const onlyDocs = data.filter((f) =>
      //   allowedMimeTypes.includes(f.type?.toLowerCase())
      // );
      // console.log("Fetched uploaded documents:", data);
      setUploadedFilesList(data);
      // calculateSummaryStats(data);
    } catch (err) {
      console.error("Error fetching uploaded documents:", err);
      showErrorToast(TOAST_MESSAGES.FILE.FAILED);
    }
  };

  useEffect(() => {
    fetchUploadedFiles();
  }, []);

  const allowedExtensions = [
    "pdf",
    "docx",
    "txt",
    "doc",
    "pptx",
    "xlsx",
    "mp3",
    "wav",
    "aac",
    "flac",
    "mp4",
    "mov",
    "avi",
    "mkv",
    "flv",
    "png",
    "jpg",
    "jpeg",
    "gif",
    "bmp",
    "tiff",
  ];

  const handleFileSelect = (e) => {
    const newFiles = Array.from(e.target.files);
    if (!newFiles.length) return;

    const updatedFiles = [...selectedFiles];

    const supportedFiles = [];
    const unsupportedFiles = [];

    // 1️⃣ Split supported + unsupported by extension
    newFiles.forEach((file) => {
      const ext = file.name.split(".").pop().toLowerCase();

      if (allowedExtensions.includes(ext)) {
        supportedFiles.push(file);
      } else {
        unsupportedFiles.push(file);
      }
    });

    // 🔔 Notify unsupported formats
    if (unsupportedFiles.length > 0) {
      showErrorToast(
        `Unsupported file format: ${unsupportedFiles
          .map((f) => f.name)
          .join(", ")}`,
      );
    }

    // 🚫 Stop if nothing supported
    if (supportedFiles.length === 0) {
      e.target.value = "";
      return;
    }

    // 2️⃣ Validate filenames (NON-blocking)
    const validNameFiles = [];
    const invalidNameFiles = [];

    for (const file of supportedFiles) {
      const { valid, reason } = validateFileName(file.name);

      if (valid) {
        validNameFiles.push(file);
      } else {
        invalidNameFiles.push({ name: file.name, reason });
      }
    }

    // 🔔 Notify invalid filenames
    if (invalidNameFiles.length > 0) {
      invalidNameFiles.forEach((f) => showErrorToast(`${f.name}: ${f.reason}`));
    }

    // ⛔ Stop if nothing valid remains
    if (validNameFiles.length === 0) {
      e.target.value = "";
      return;
    }

    // 3️⃣ Add only non-duplicate valid files
    validNameFiles.forEach((file) => {
      const exists = updatedFiles.some(
        (f) => f.name === file.name && f.size === file.size,
      );

      if (!exists) {
        updatedFiles.push(file);
      }
    });

    setSelectedFiles(updatedFiles);
    e.target.value = "";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFileSelect({ target: { files: e.dataTransfer.files } });
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleDelete = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
  };

  const handleCancel = () => {
    // if no documents present, just ignore
    if (!selectedFiles || selectedFiles.length === 0) {
      showErrorToast("No document to cancel.");
      return;
    }

    setIsCancelling(true);
    setTimeout(() => {
      setSelectedFiles([]);
      fileInputRef.current.value = null;
      setIsCancelling(false);
    }, 500);
  };

  const handleChangeStatus = async (fileId, newStatus) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/approve-or-reject`,
        { file_id: fileId, approval_status: newStatus, notes: "" },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      showSuccessToast(`Status updated to ${newStatus}`);
      fetchUploadedFiles();
    } catch (err) {
      console.error("❌ Error updating status:", err);
      showErrorToast("Failed to update status");
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  // 🆕 Fetch summary after upload
  const fetchSummaryFromBackend = async (uploadIds) => {
    try {
      const idsQuery = uploadIds.join(",");
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/uploaded-files/summary?ids=${idsQuery}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setSummaryDataList(res.data);
      setShowSummaryModal(true);
    } catch (err) {
      console.error("Failed to fetch summaries:", err);
      showErrorToast("Failed to fetch summaries.");
    }
  };

  // 🆕 Regenerate specific summary
  const regenerateSummary = async (fileId, index) => {
    try {
      setLoadingIndex(index); // 🚫 disable button for this index

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/regenerate-summary`,
        { file_id: fileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const newSummary = res.data.summary;

      setSummaryDataList((prevList) => {
        const updatedList = [...prevList];
        updatedList[index] = {
          ...updatedList[index],
          summary: newSummary,
        };
        return updatedList;
      });

      showSuccessToast("Summary regenerated!");
    } catch (err) {
      console.error("Failed to regenerate summary:", err);
      showErrorToast("Regeneration failed.");
    } finally {
      setLoadingIndex(null); // ✅ re-enable button
    }
  };

  // console.log("selectedUser", selectedUserObj);

  const handleUpload = async () => {
    let duplicateCheckResponse;

    try {
      if (selectedFiles.length === 0) {
        showErrorToast("Please select at least one file!");
        return;
      }

      // ✅ Personal role validation
      if (
        role === "personal" &&
        (!selectedUserObj || Object.keys(selectedUserObj).length === 0)
      ) {
        showErrorToast("Please select the user");
        return;
      }

      // ✅ Group role validation
      if (role === "group" && !selectedGroupId) {
        showErrorToast("Please select the group");
        return;
      }

      setIsAdded(true);

      /* ===========================
       1️⃣ CHECK DUPLICATES
    ============================ */
      const checkFormData = new FormData();
      selectedFiles.forEach((file) => checkFormData.append("files", file));

      checkFormData.append("mode", role);

      if (role === "group") {
        checkFormData.append("department_id", selectedGroupId);
      }

      duplicateCheckResponse = await api.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/newCheckDuplicates`,
        checkFormData,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const { duplicates = [], new_files = [] } =
        duplicateCheckResponse.data || {};

      const allFileHashes = [...duplicates, ...new_files].map(
        (file) => file.file_hash,
      );

      duplicates.forEach(() => {
        showErrorToast("Duplicate file detected");
      });

      console.log("🧬 All file hashes:", allFileHashes);

      /* ===========================
       3️⃣ UPLOAD FILES
    ============================ */
      const uploadFormData = new FormData();
      selectedFiles.forEach((file) => uploadFormData.append("files", file));

      uploadFormData.append("mode", role);
      uploadFormData.append("description", Description);
      uploadFormData.append("file_hash", JSON.stringify(allFileHashes));

      if (role === "personal") {
        uploadFormData.append("userObj", JSON.stringify(selectedUserObj));
      }

      if (role === "group") {
        uploadFormData.append("department_id", selectedGroupId);
      }

      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/uploaded-files/newUpload`,
        uploadFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );

      /* ===========================
       4️⃣ UI FEEDBACK
    ============================ */
      const uploadedCount = response?.data?.uploaded || 0;

      if (uploadedCount > 0) {
        showSuccessToast(`Uploaded ${uploadedCount} file(s) successfully.`);
      } else {
        showErrorToast("No new files were uploaded.");
      }

      /* ===========================
       5️⃣ CLEANUP
    ============================ */
      setSelectedFiles([]);
      setDescription("");
      setSelectedUserId("");
      setSelectedUserObj(null);
      fileInputRef.current.value = null;
      fetchUploadedFiles();

      const uploadIds =
        response.data.uploaded_files?.map((f) => f.python_file_uuid) || [];

      if (uploadIds.length > 0) {
        await fetchSummaryFromBackend(uploadIds);
      }
    } catch (err) {
      const status = err?.response?.status;
      const data = err?.response?.data;

      console.error("Upload failed:", err);

      if (status === 409 && data?.toasts?.length > 0) {
        data.toasts.forEach((toast) => showErrorToast(toast.message));
        return;
      }

      showErrorToast("File upload failed! Please try again.");
    } finally {
      setIsAdded(false);
    }
  };

  const handlePreview = async (file) => {
    try {
      const res = await fetch(
        `${
          process.env.REACT_APP_API_URL
        }/uploaded-files/download/${encodeURIComponent(file.storedName)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!res.ok) throw new Error("Failed to fetch preview");

      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);

      setSelectedFile({ ...file, previewUrl: blobUrl }); // Preview state set with blob URL
      setShowModal(true); // Show modal
    } catch (err) {
      console.error("Preview fetch failed:", err);
      showErrorToast("Unable to preview file.");
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await api.get(BASE_URL, {
        headers: { Authorization: `Bearer ${token}` },
        params: { limit: "all" },
      });
      setUsers(res.data.data); // 👈 store user list
    } catch (error) {
      console.error("Failed to fetch users", error);
      showErrorToast(TOAST_MESSAGES.USER.FETCH_ERROR);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    if (role !== "group") {
      setDepartments([]);
      setSelectedGroupId("");
      return;
    }

    const fetchDepartments = async () => {
      try {
        setIsDeptLoading(true);

        const res = await api.get(DEPARTMENTS_URL, {
          headers: { Authorization: `Bearer ${token}` },
          // params: { enterprise_id }
        });

        const deptData = Array.isArray(res.data)
          ? res.data
          : res.data?.data || [];

        setDepartments(deptData);
      } catch (error) {
        console.error("Failed to fetch departments", error);
        showErrorToast("Failed to load departments");
      } finally {
        setIsDeptLoading(false);
      }
    };

    fetchDepartments();
  }, [role]);

  // ===== SUMMARY CALCULATIONS =====
  const BASE_LIMIT = 0.1 * 1024 * 1024; // 5 MB
  // const BASE_LIMIT = 15360 * 1024 * 1024; // 15 GB
  const STEP = 1 * 1024 * 1024; // 1 MB

  // total size
  const totalSize = uploadedFilesList.reduce(
    (sum, file) => sum + (file.size || 0),
    0,
  );

  // dynamic limit
  const calculatedLimit =
    totalSize <= BASE_LIMIT ? BASE_LIMIT : Math.ceil(totalSize / STEP) * STEP;

  // completion %
  const completionPercent = Math.min(
    Math.round((totalSize / calculatedLimit) * 100) || 0,
    100,
  );

  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
  };

  // important file types only
  const IMPORTANT_TYPES = [
    "pdf",
    "doc",
    "docx",
    "txt",
    "pptx",
    "xlsx",
    "mp3",
    "wav",
    "aac",
    "flac",
    "mp4",
    "mov",
    "avi",
    "mkv",
    "flv",
    "png",
    "jpg",
    "jpeg",
    "gif",
    "bmp",
    "tiff",
  ];

  // group by type
  const byType = {};
  uploadedFilesList.forEach((file) => {
    const ext = file.name?.split(".").pop()?.toLowerCase();
    if (!IMPORTANT_TYPES.includes(ext)) return;

    byType[`.${ext}`] = (byType[`.${ext}`] || 0) + (file.size || 0);
  });

  const { sortedData, requestSort, sortConfig } =
    useTableSort(uploadedFilesList);

  // convert to summary stats
  const summaryStats = Object.entries(byType).map(([type, size]) => ({
    type,
    percent: Math.min(Math.round((size / calculatedLimit) * 100), 100),
  }));

  return (
    <div
      className="container-fluid mt-2 h-100"
      style={{ paddingBottom: "800px" }}
    >
      <div className="row">
        {/* LEFT: File Upload and Preview */}
        <div className="col-lg-8">
          <div className="card profile shadow-sm rounded-lg p-4">
            <h5 className="fw-bold mb-3 ak-text-lg">Upload Documents</h5>
            {/* Radio Buttons */}
            <div className="d-flex gap-4 justify-content-between align-items-center mb-2">
              <div className="gap-2 d-flex">
                <label className="radio-label mb-0">
                  <input
                    type="radio"
                    name="role"
                    value="personal"
                    checked={role === "personal"}
                    onChange={() => setRole("personal")}
                  />
                  <span className="ms-2">Personal</span>
                </label>

                <label className="radio-label mb-0">
                  <input
                    type="radio"
                    name="role"
                    value="global"
                    checked={role === "global"}
                    onChange={() => {
                      setRole("global");
                      setSelectedUserId("");
                    }}
                  />
                  <span className="ms-2">Gobal</span>
                </label>
                {/* Group */}
                <label className="radio-label mb-0">
                  <input
                    type="radio"
                    name="role"
                    value="group"
                    checked={role === "group"}
                    onChange={() => {
                      setRole("group");
                      setSelectedUserId("");
                      setSelectedGroupId("");
                    }}
                  />
                  <span className="ms-2">Group</span>
                </label>
              </div>
              {role === "personal" && (
                <div className="col-md-4">
                  <select
                    className="form-select ak-text-sm"
                    value={selectedUserId}
                    onChange={(e) => {
                      const userId = e.target.value; // 👈 keep string

                      const user = users.find(
                        (u) => String(u.user_id) === userId,
                      );

                      // console.log("Found user:", user); // 🔍 debug

                      setSelectedUserId(userId);
                      setSelectedUserObj(user);
                    }}
                    disabled={role === "global"}
                  >
                    <option
                      value=""
                      className="ak-text-sm"
                      style={{ fontSize: "var(--ak-font-sm)" }}
                    >
                      Select User
                    </option>
                    {users
                      .filter(
                        (user) =>
                          user.Role?.role_name !== "Admin" &&
                          user.Role?.role_name !== "SuperAdmin",
                      )
                      .map((user) => (
                        <option
                          key={user.user_id}
                          value={user.user_id}
                          className="ak-text-sm"
                        >
                          {user.user_name}
                        </option>
                      ))}
                  </select>
                </div>
              )}
              {role === "group" && (
                <div className="col-md-4">
                  <select
                    className="form-select ak-text-sm"
                    value={selectedGroupId}
                    onChange={(e) => setSelectedGroupId(e.target.value)}
                    disabled={isDeptLoading}
                  >
                    <option value="">Select Group</option>

                    {isDeptLoading && (
                      <option disabled>Loading groups...</option>
                    )}

                    {!isDeptLoading && departments.length === 0 && (
                      <option disabled>No groups found</option>
                    )}

                    {!isDeptLoading &&
                      departments.map((dept) => (
                        <option
                          key={dept.department_id}
                          value={dept.department_id}
                        >
                          {dept.department_name}
                        </option>
                      ))}
                  </select>
                </div>
              )}
            </div>

            {/* Top Row */}
            <div className="row g-3 mb-3 d-flex justify-content-center"></div>

            <div
              className="border-2 rounded p-4 mb-3 text-center"
              onClick={() => !isAdded && fileInputRef.current.click()}
              onDrop={isAdded ? (e) => e.preventDefault() : handleDrop}
              onDragOver={isAdded ? (e) => e.preventDefault() : handleDragOver}
              style={{
                cursor: isAdded ? "not-allowed" : "pointer", // 👈 show disabled cursor
                minHeight: "240px",
                borderStyle: "dashed",
                border: "dashed var(--input-border-color)",
                pointerEvents: isAdded ? "none" : "auto", // 👈 block all events while uploading
              }}
            >
              <input
                type="file"
                ref={fileInputRef}
                multiple
                className="d-none "
                accept=".pdf,.docx,.txt,.doc,.pptx,.xlsx,.mp3,.wav,.aac,.flac,.mp4,.mov,.avi,.mkv,.flv,.png,.jpg,.jpeg,.gif,.bmp,.tiff"
                onChange={handleFileSelect}
              />

              {selectedFiles.length === 0 && (
                <div className="">
                  {/* <i className="bi bi-cloud-arrow-up fs-1" /> */}
                  <div className="w-100 d-flex align-items-center justify-content-center">
                    <div
                      className="rounded-circle align-self-center border border-2 d-flex justify-content-center align-items-center p-2 p-md-3 mb-3"
                      style={{
                        width: "60px",
                        height: "60px",
                        borderStyle: "dashed",
                        border: "dashed var(--input-border-color)",
                        // borderColor: "var(--border-color)",
                        backgroundColor: "var(--bot-bubble-color)",
                      }}
                    >
                      <img
                        src={uploadIcon}
                        alt="Upload"
                        className="icon-image1"
                        style={{
                          width: "40px ",
                          // maxHeight: "40px",

                          transition: "filter 0.3s ease",
                        }}
                      />
                    </div>
                  </div>
                  <p className="mb-1 fw-semibold">Drag and Drop here</p>
                  <p className=" fw-semibold mb-1">or</p>
                  <button
                    className="bg-secondary"
                    type="button"
                    onClick={(e) => e.currentTarget.blur()}
                    disabled={isAdded}
                    style={{
                      marginTop: "8px",
                      padding: "8px 16px",
                      // backgroundColor: isAdded ? "#cccccc" : "var(--secondary-color)",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      cursor: isAdded ? "not-allowed" : "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i className="bi bi-folder2-open" /> Browse Files
                  </button>
                  <p
                    className="small mt-2 supported-text"
                    style={{ color: "var(--dark-color)" }}
                  >
                    {/* Supported: .pdf, .doc, .docx, .txt, .mp3, .wav, .mp4,
                    .avi, .mov, .mkv, .png, .jpg, .jpeg, .ppt, .pptx */}
                    {/* Supported: .pdf, .docx, .txt, .mp3, .mp4, .png, .jpeg, pptx */}
                  </p>
                </div>
              )}

              {selectedFiles.length > 0 && (
                <div
                  className="d-flex flex-column gap-2 overflow-auto"
                  style={{ maxHeight: "200px" }}
                >
                  {selectedFiles.map((file, index) => (
                    <div
                      className="d-flex justify-content-between align-items-center border rounded px-3 py-2"
                      key={index}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-file-earmark-fill  fs-5" />
                        <span className="fw-semibold">{file.name}</span>
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(index);
                        }}
                        className="btn btn-sm text-danger border-0"
                      >
                        <i className="bi bi-trash-fill fs-5" />
                      </button>
                    </div>
                  ))}

                  <div className="text-center mt-3">
                    <button
                      type="button"
                      className="custom-btn d-flex align-items-center gap-2 mx-auto"
                      onClick={(e) => {
                        if (isAdded) return; // 👈 block click during upload
                        e.stopPropagation();
                        fileInputRef.current.click();
                        e.currentTarget.blur();
                      }}
                      disabled={isAdded} // 👈 disable button
                      style={{
                        opacity: isAdded ? 0.6 : 1,
                        cursor: isAdded ? "not-allowed" : "pointer",
                      }}
                    >
                      <i className="bi bi-plus-lg" /> Add More Files
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Description */}
            <div
              className="fw-semibold mb-1 d-flex align-items-center ak-text-lg mt-2"
              style={{ color: "var(--dark-color)" }}
            >
              Description
            </div>

            <textarea
              className="form-control custom-textarea rounded-3 px-2 px-md-4 py-1 py-md-2 mb-2"
              placeholder="Write here..."
              value={Description}
              onChange={(e) => setDescription(e.target.value)}
              style={{
                borderWidth: "1.5px",
                minHeight: "40px",
                resize: "vertical",
                fontSize: "14px",
                backgroundColor: "var(--background-color)",
                borderColor: "var(--border-color)",
                color: "var(--dark-color)",
              }}
            />

            <div className="d-flex gap-3">
              <button
                type="button"
                className="cancle-btn flex-fill border-1 w-50 fw-semibold"
                // style={{ borderColor: "#3e3e3e" }}
                onClick={handleCancel}
                disabled={isCancelling}
              >
                {isCancelling ? (
                  <>
                    {/* <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    /> */}
                    Cancelling...
                  </>
                ) : (
                  "Cancel"
                )}
              </button>
              <button
                className="custom-btn w-50 fw-semibold "
                // style={{ backgroundColor: "#3e3e3e" }}
                onClick={handleUpload}
                disabled={isAdded}
              >
                {isAdded ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>

          <div className="mt-4">
            <div
              className="table-responsive"
              style={{ maxHeight: "330px", overflowY: "auto" }}
            >
              <table className="table trainingFiles-table text-left align-middle mb-0">
                <thead className="">
                  <tr>
                    <SortableHeader
                      column="name"
                      label="Document Name"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />
                    <SortableHeader
                      column="type"
                      label="Type"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />
                    <SortableHeader
                      column="size"
                      label="Size"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />
                    <SortableHeader
                      column="approval_status"
                      label="Status"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />
                    <SortableHeader
                      column="updatedAt"
                      label="Uploaded On"
                      sortConfig={sortConfig}
                      onSort={requestSort}
                    />

                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {sortedData.length > 0 ? (
                    sortedData.map((file, index) => (
                      <tr key={file.id || index} className="bg-light">
                        <td
                          style={{
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={file.name}
                        >
                          {file.name}
                        </td>
                        <td
                          style={{
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {formatFileType(file.type, file.name)}
                        </td>
                        <td>{formatFileSize(file.size)}</td>
                        <td>
                          <select
                            className={`badge ${
                              file.approval_status === "approved"
                                ? "bg-success"
                                : file.approval_status === "duplicate"
                                  ? "bg-secondary"
                                  : file.approval_status === "pending"
                                    ? "bg-warning"
                                    : "bg-danger"
                            }`}
                            value={file.approval_status}
                            onChange={(e) =>
                              handleChangeStatus(file.id, e.target.value)
                            }
                          >
                            <option value="pending">Pending</option>
                            <option value="approved">Approved</option>
                            <option value="rejected">Rejected</option>
                            {/* <option value="duplicate">Duplicate</option> */}
                          </select>
                        </td>

                        <td>
                          {formatDateToUserTimeZone(new Date(file.updatedAt))}
                        </td>
                        {/* <td>
                            <button
                              className="btn btn-sm btn-outline-dark"
                              onClick={() => {
                                handlePreview(file); // ✅ Call preview logic
                              }}
                            >
                              <i className="bi bi-eye" />
                            </button>
                          </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="refresh-prompts ak-text-md">
                        No documents have been trained yet.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* RIGHT - Summary Card */}
        <div className="col-lg-4">
          <div className="card profile p-4 shadow-sm">
            <h5 className="fw-semibold mb-4 ak-text-lg">Summary</h5>

            {/* Circular Progress */}
            <div className="d-flex justify-content-center align-items-center mb-4 position-relative">
              <svg
                width="140"
                height="140"
                viewBox="0 0 36 36"
                className="circular-chart"
              >
                <path
                  d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#eee"
                  strokeWidth="2"
                />
                <path
                  d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                  fill="none"
                  stroke="#3e3e3e"
                  strokeWidth="2"
                  strokeDasharray={`${completionPercent}, 100`}
                />
              </svg>

              <div className="position-absolute text-center">
                <div className="ak-text-md">Complete</div>
                <div className="fw-bold fs-2">{completionPercent}%</div>
              </div>
            </div>

            {/* Size Info */}
            <div className="row text-center mb-4">
              <div className="col">
                <div className="ak-text-md fw-semibold">Total Size</div>
                <div className="fw-semibold">{formatBytes(totalSize)}</div>
              </div>
              <div className="col">
                <div className="ak-text-md fw-semibold">Limits</div>
                <div className="fw-semibold">
                  {formatBytes(calculatedLimit)}
                </div>
              </div>
            </div>

            {/* By File Type */}
            {summaryStats.length > 0 ? (
              summaryStats.map((doc, idx) => (
                <div key={idx} className="mb-3">
                  <div className="d-flex justify-content-between ak-text-md fw-semibold">
                    <span className="text-secondary">{doc.type}</span>
                    <span>{doc.percent}%</span>
                  </div>
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className="progress-bar bg-dark"
                      role="progressbar"
                      style={{ width: `${doc.percent}%` }}
                    />
                  </div>
                </div>
              ))
            ) : (
              <p className="refresh-prompts ak-text-sm">No data available</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingManagement;
